// Module
var code = `talentExpertHiringFunnelCandidateComponent`;
// Exports
export default code;